import { useMemo } from 'react';
import Label from 'react-rainbow-components/components/Input/label';
import ListTile from 'components/ListTile';
import UserAvatar from 'components/UserAvatar';
import formatIntlPhoneNumber from 'data/services/phone/formatter';
import getDisplayName from 'data/services/profile/getDisplayName';
import getInitials from 'data/services/string/getInitials';
import {
    CompactName,
    CompactPhone,
    CompactValue,
    InnerContainer,
    StyledChip,
    ValueContainer,
} from './styled';

interface Params {
    id?: string;
    className?: string;
    label?: string;
    required?: boolean;
    disabled?: boolean;
    compact?: boolean;
    value: any;
    onClearValue?: () => void;
}

const SelectedValue = ({
    id,
    className,
    label,
    required = false,
    disabled = false,
    compact = false,
    value,
    onClearValue = () => {},
}: Params) => {
    const displayName = useMemo(() => getDisplayName(value), [value]);
    const phone = useMemo(
        () => formatIntlPhoneNumber(value.phoneNumber),
        [value.phoneNumber],
    );

    const initials = useMemo(() => (
        displayName === 'Unknown'
            ? null
            : getInitials(displayName)
    ), [displayName]);

    const chipLabel = compact
        ? (
            <CompactValue>
                <UserAvatar
                    size="small"
                    initials={initials}
                    value={value.id}
                    src={value.photoURL}
                />
                <CompactName>{displayName}</CompactName>
                {phone ? <CompactPhone>{phone}</CompactPhone> : null}
            </CompactValue>
        )
        : (
            <ListTile
                icon={(
                    <UserAvatar
                        initials={initials}
                        value={value.id}
                        src={value.photoURL}
                    />
                )}
                title={displayName}
                subtitle={phone}
            />
        );

    return (
        <ValueContainer id={id} className={className}>
            {label && (
                <Label
                    label={label}
                    labelAlignment="left"
                    required={required}
                />
            )}
            <InnerContainer>
                <StyledChip
                    $compact={compact}
                    $disabled={disabled}
                    label={chipLabel}
                    borderRadius="semi-square"
                    onDelete={disabled ? undefined : onClearValue}
                />
            </InnerContainer>
        </ValueContainer>
    );
};

export default SelectedValue;
